module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.e1aab3dd.png";